import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { activationStrategy } from 'aurelia-router';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { Config } from 'Config';

export class BaseCustomElement {

    // unique id property
    protected guid: string = null;
    protected apiUrl: string = null;
    protected instanceUrl: string = null;
    protected instanceName: string = null;
    protected userToken: string = null;
    protected isOnline: boolean = true;

    // set activation strategy
    protected determineActivationStrategy() {
        return activationStrategy.invokeLifecycle;
    }

    // base contructor
    constructor() {
        this.guid = GuidHelper.NewGuid();
        this.apiUrl = Config.ApiUrl();
        this.instanceUrl = Config.InstanceUrl();
        this.instanceName = Config.InstanceName();
        this.isOnline = Config.IsOnline();
        this.userToken = JSON.parse(localStorage[Config.TokenName()] || null).Token;
    }

    //testing values
    public ObjectIs(item: any): boolean {
        return ObjectHelper.IsNotNullAndUndefinedAndEmpty(item);
    }
    public StringIs(item: any): boolean {
        return StringHelper.IsNotNullAndEmptyAndUndefined(item);
    }
    public ArrayIs(item: any): boolean {
        return (this.ObjectIs(item) && item.length > 0)
    }
}